import qs from 'qs';
import GeneralsHelper from '../helpers/generalsHelper';
import socketio from 'socket.io-client';
import { RemoveCredentialsApp } from '../helpers/utils';

class MainServices {
  static KEY_ENCRIPT_STORAGE = 'GsXziOutZNflysF1sJLsTQv/2AxJAUtXbABjCJonw5Q=';

  static KEY_GOOGLE_MAP = 'AIzaSyAFZbuaSYS4miJI3Js77n1tj6xUVXYq14M';

  static URL_GOOGLE_MAP = `https://maps.googleapis.com/maps/api/js?key=${this.KEY_GOOGLE_MAP}&libraries=places&libraries=drawing&libraries=geometry`;

  static SEPARADOR = '/';

  static HOST_ARRAY =
    window.location.host && window.location.host.search('localhost') < 0 ? window.location.host.split('.') : ['localhost'];

  static IS_PROD = this.HOST_ARRAY?.length > 1;

  static HOST_CURRENT = `${
    this.IS_PROD ? `${this.HOST_ARRAY[0]}-backend.${this.HOST_ARRAY[1]}.${this.HOST_ARRAY[2]}` : this.HOST_ARRAY[0]
  }`;

  static URL_SERVER = `${window.location.protocol}//${this.HOST_CURRENT}/${
    this.IS_PROD ? 'public/' : 'domo-crm/domo-crm-backend/public/'
  }`;

  // static URL_SERVER ="https://bl-backend.domo-crm.com/public/"
  //static URL_SERVER = 'https://diners-inversiones-backend.domo-crm.com/public/';
  //static URL_SERVER = 'https://deuna-backend.domo-crm.com/public/';
  //static URL_SERVER = 'https://diners-empresas-backend.domo-crm.com/public/';
  //static URL_SERVER = 'https://diners-fventas-backend.domo-crm.com/public/';
  //static URL_SERVER = 'https://redime-backend.domo-crm.com/public/';
  static URL_LARAVEL_ECHO_SERVER = `${window.location.protocol}//${this.HOST_CURRENT}:${this.getPortSocket(
    window.location.host,
  )}`;

  static API_PATH = `${this.URL_SERVER}api/`;

  static MODULO_PATH = 'modulo/';

  static API_PATH_FILES = `${this.URL_SERVER}api/admin/file-system/getFile`;
  static COUNTRY = this.getCountry(window.location.host);
  // #region CONFIGURATION OPTIONS FOR SOCKETS
  static echoConfiguration = {
    broadcaster: 'socket.io',
    host: MainServices.URL_LARAVEL_ECHO_SERVER,
    wssHost: MainServices.URL_LARAVEL_ECHO_SERVER,
    wssPort: this.getPortSocket(window.location.host),
    disableStats: true,
    client: socketio,
    transports: ['websocket'],
    auth: {},
    timeout: 10000, // 10s máx para conectar
    reconnection: true,
    reconnectionAttempts: 5, // 🔴 CLAVE
    reconnectionDelay: 20000,
    reconnectionDelayMax: 20000,
    forceNew: false,
  };
  // #endregion

  static getPortSocket(host) {
    switch (host) {
      case 'diners-inversiones.domo-crm.com':
        return 6002;
      case 'diners-fventas.domo-crm.com':
        return 6003;
      case 'deuna.domo-crm.com':
        return 6004;
      case 'redime.domo-crm.com':
        return 6005;
      case 'redime-ventas.domo-crm.com':
        return 6006;
      case 'elnacional.domo-crm.com':
        return 6007;
      case 'blue.domo-crm.com':
        return 6008;
      case 'ms.domo-crm.com':
        return 6009;
      case 'trial.domo-crm.com':
        return 6010;
      default:
        return 6001;
    }
  }

  static getSubdomain(host) {
    return host.replace('.domo-crm.com', '');
  }
  static getCountry(host) {
    switch (host) {
      case 'bombai.domo-crm.com':
        return 'co';
      default:
        return 'ec';
    }
  }
  static getApiBaseURL(baseNombre, modeloNombre, modeloId, funcionesExtras, parametros) {
    return (
      this.API_PATH +
      baseNombre +
      this.SEPARADOR +
      modeloNombre +
      (modeloId > 0 ? this.SEPARADOR + modeloId : '') +
      (funcionesExtras !== null ? this.SEPARADOR + funcionesExtras : '') +
      (parametros !== null ? `?${qs.stringify(parametros)}` : '')
    );
  }

  static getModuloURLAdminwithFunction(modulo, modeloName, modeloId, funcionName, parametros) {
    return (
      this.API_PATH +
      modulo +
      this.SEPARADOR +
      modeloName +
      (modeloId > 0 ? this.SEPARADOR + modeloId : '') +
      this.SEPARADOR +
      funcionName +
      (parametros !== null ? `?${qs.stringify(parametros)}` : '')
    );
  }

  static getModuloAdminURL(modulo, modeloName, modeloId, parametros) {
    return (
      this.API_PATH +
      modulo +
      this.SEPARADOR +
      modeloName +
      (modeloId > 0 ? this.SEPARADOR + modeloId : '') +
      (parametros !== null ? `?${qs.stringify(parametros)}` : '')
    );
  }

  static getAdminURL(recurso) {
    return `${this.API_PATH}admin/${recurso}`;
  }

  static processResponse(success, response, error) {
    if (!success) {
      if (GeneralsHelper.isset(() => error.response) && GeneralsHelper.isset(() => error.response.data)) {
        response = error.response.data;
      } else {
        response = {
          satisfactory: false,
          title: error.message,
          message: error.message,
          data: null,
          code: error.status,
        };
      }
    }
    if (response.code === 401) RemoveCredentialsApp();
    return response;
  }

  static getFiltrosCruds(filtros) {
    const Filtros = [];

    filtros.map((filtro) => {
      if (filtro.valor !== '') {
        const datosFiltro = {
          nombreCampo: filtro.nombreCampo,
          tipoBusqueda: filtro.tipoBusqueda,
          valor: filtro.valor,
        };

        Filtros.push(datosFiltro);
      }
      return filtro;
    });

    return Filtros;
  }
}

export default MainServices;
